/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SelfControlContainer,
  SelfControlContainerDto,
  SelfControlItem
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiSelfControlContainerProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlContainerDto>(
      {url: `/api/SelfControlContainer/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSelfControlContainerProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/SelfControlContainer/${projectId}`
    ] as const;
    }


export const getGetApiSelfControlContainerProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSelfControlContainerProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>> = ({ signal }) => getApiSelfControlContainerProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSelfControlContainerProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>>
export type GetApiSelfControlContainerProjectIdQueryError = ErrorType<unknown>


export function useGetApiSelfControlContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSelfControlContainerProjectId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSelfControlContainerProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSelfControlContainerItemsId = (
    id: number,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlItem[]>(
      {url: `/api/SelfControlContainer/Items/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiSelfControlContainerItemsIdQueryKey = (id: number,) => {
    return [
    `/api/SelfControlContainer/Items/${id}`
    ] as const;
    }


export const getGetApiSelfControlContainerItemsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiSelfControlContainerItemsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>> = ({ signal }) => getApiSelfControlContainerItemsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSelfControlContainerItemsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>>
export type GetApiSelfControlContainerItemsIdQueryError = ErrorType<unknown>


export function useGetApiSelfControlContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>,
          TError,
          Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSelfControlContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiSelfControlContainerItemsId<TData = Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiSelfControlContainerItemsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiSelfControlContainerItemsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiSelfControlContainer = (
    selfControlContainerDto?: BodyType<SelfControlContainerDto>,
 signal?: AbortSignal
) => {


      return customInstance<SelfControlContainer>(
      {url: `/api/SelfControlContainer`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: selfControlContainerDto, signal
    },
      );
    }




export const getPutApiSelfControlContainerMutationKey = () => ['putApiSelfControlContainer'] as const;

export const getPutApiSelfControlContainerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlContainer>>, TError,PutApiSelfControlContainerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlContainer>>, TError,PutApiSelfControlContainerMutationVariables, TContext> => {

const mutationKey = getPutApiSelfControlContainerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiSelfControlContainer>>, PutApiSelfControlContainerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiSelfControlContainer(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiSelfControlContainerMutationResult = NonNullable<Awaited<ReturnType<typeof putApiSelfControlContainer>>>
    export type PutApiSelfControlContainerMutationBody = BodyType<SelfControlContainerDto> | undefined
    export type PutApiSelfControlContainerMutationError = ErrorType<unknown>
    export type PutApiSelfControlContainerMutationVariables = {data?: BodyType<SelfControlContainerDto>}

    export const usePutApiSelfControlContainer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiSelfControlContainer>>, TError,PutApiSelfControlContainerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiSelfControlContainer>>,
        TError,
        PutApiSelfControlContainerMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiSelfControlContainerMutationOptions(options), queryClient);
    }
